module.exports = __webpack_public_path__ + "static/media/reset-password-img.827c90f1.png";